import { req, post } from '@/plugins/axios'

/**
* 获取新手指引
* @param {Object} data
*/
export function getGuide (data: any) {
  return req('/customer/showGuide', data)
}

/**
* 更新新手指引
* @param {Object} data
*/
export function updateGuide (data: any) {
  return post('/customer/updateGuide', data)
}
